import React = require("react")
import { SearchBar } from "../searchBar/searchBarLayout";
import { SearchModalLayoutProps } from "./searchModalState";

export const SearchModalLayout = (props: SearchModalLayoutProps) =>
  <div id="a11y-search-modal" aria-hidden={!props.isOpen} className="search-modal" key="search-modal">
    <div className="search-modal__inner container--mg align--center">
      <div className="search-modal__content">
        <div className="form form--search search--modal">
          <h1 className="sr-text">Zoeken</h1>
          <label htmlFor="site-search-modal" className="form__label search__label title--m">Zoek in de site</label>
          <div className="search__input-container form__item--icon left">
            <SearchBar id="site-search-modal"
              query={props.searchQuery}
              updateSearchQuery={(newQuery) => props.updateQuery(newQuery)}
              runSearchQuery={() => props.runSearch()}
            />
          </div>

          <button
            className="link link--iconed search-modal__close"
            onClick={() => props.toggleSearchModal()}
            aria-controls="a11y-search-modal"
            aria-expanded={props.isOpen}
          >
            <span className="text--xs">Sluiten</span>
            <svg className="link__icon" width="14px" height="14px" aria-hidden="true"><use xlinkHref="#icon--close-dnb" /></svg>
          </button>
        </div>
      </div>
    </div>

    <div className="search-modal__overlay" aria-hidden="true" onClick={() => props.toggleSearchModal()} />
  </div>
